module.exports = __webpack_public_path__ + "static/media/five.bc6a9bd6.svg";